import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckInitGuard } from './checkInit/check-init.guard';
import pathSoftware from '../components/webapp-software-001/config/path/path.json'

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./home1/home1.module').then((m) => m.Home1Module),
    },
    {
        path: 'tai-sales',
        loadChildren: () => import('./download-app-sales/download-app-sales.module').then((m) => m.DownloadAppSalesModule),

    },
    {
        path: 'tai-cafe',
        loadChildren: () => import('./download-app-cafe/download-app-cafe.module').then((m) => m.DownloadAppCafeModule),

    },
    {
        path: 'introduction',
        loadChildren: () => import('./introduction1/introduction1.module').then((m) => m.Introduction1Module),

    },
    {
        path: 'software',
        loadChildren: () => import('./software1/software1.module').then((m) => m.Software1Module),

    },
    {
        path: `${pathSoftware.link}`,
        loadChildren: () => import('../components/webapp-software-001/user/webapp-software-001-user.module').then(m => m.WebappSoftware001UserModule),
        canActivate: [CheckInitGuard]
    },

    {
        path: 'solution',
        loadChildren: () => import('./solution1/solution1.module').then((m) => m.Solution1Module),

    },
    {
        path: 'outsource',
        loadChildren: () => import('./outsourcing/outsourcing.module').then((m) => m.OutsourcingModule),

    },
    {
        path: 'tin-tuc',
        loadChildren: () => import('./news/news.module').then((m) => m.NewsModule),

    },
    {
        path: 'support',
        loadChildren: () => import('./support/support.module').then((m) => m.SupportModule),

    },
    {
        path: 'price',
        loadChildren: () => import('./price-list/price-list.module').then((m) => m.PriceListModule),

    },
    {
        path: 'contact',
        loadChildren: () => import('./contact/contact.module').then((m) => m.ContactModule),

    },
    {
        path: 'recruitment',
        loadChildren: () => import('./recruitment/recruitment.module').then((m) => m.RecruitmentModule),

    },
    {
        path: 'download',
        loadChildren: () => import('./download/download.module').then((m) => m.DownloadModule),
    },
    {
        path: 'quy-dinh-su-dung-phan-mem',
        loadChildren: () => import('./regulations/regulations.module').then((m) => m.RegulationsModule),
    },
    {
        path: 'privacy-policy',
        loadChildren: () => import('./privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
    },
    {
        path: 'san-pham',
        loadChildren: () => import('./Product1/product1.module').then((m) => m.Product1Module)
    },
    {
        path: 'kho-giao-dien',
        loadChildren: () => import('../components/webapp-interface-store-001/user/webapp-interface-store-c001-user.module').then((m) => m.WebappInterfaceStoreC001UserModule)
    },
    {
        path: 'promotion-sales',
        loadChildren: () => import('../components/webapp-promotion-sales-001/user/webapp-promotion-sales-c001-user/webapp-promotion-sales-c001-user.module').then((m) => m.WebappPromotionSalesC001UserModule)
    },
    {
        path: 'promotion-cafe',
        loadChildren: () => import('../components/webapp-promotion-cafe-001/user/webapp-promotion-cafe-c001-user/webapp-promotion-cafe-c001-user.module').then((m) => m.WebappPromotionCafeC001UserModule)
    },
    {
        path: 'promotion-products',
        loadChildren: () => import('../components/webapp-promotion-product-001/user/webapp-promotion-product-c001-user/webapp-promotion-product-c001-user.module').then((m) => m.WebappPromotionProductC001UserModule),
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserRoutingModule { }